import { Stack } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CheckoutDocumentForm, { UpdateCoParameter } from 'src/app/pages/accounting/documents/checkout-document/checkout-document-form'
import { DepositF, ReservationF } from '../../../types/reservation-detail.types'
import DepositsActions from './deposits-actions/deposits-actions'
import DepositsGrid from './deposits-grid/deposits-grid'
import DocumentReportViewer from 'src/app/components/report-viewer/documnent/document-report-viewer'

export type DepositsProps = {
  propertyId: string
  reservation: ReservationF
  deposits: DepositF[]
  readOnly: boolean
  selectedDepositIds: string[]
  setSelectedDepositIds: (depositId: string[]) => void
}

export default function Deposits(props: DepositsProps) {
  const { deposits, reservation, propertyId, readOnly, selectedDepositIds, setSelectedDepositIds } = props
  const { t } = useTranslation()
  const [printDocumentId, setPrintDocumentId] = useState<string | null>(null)
  const [checkoutDocumentFormParams, setCheckoutDocumentFormParams] = useState<UpdateCoParameter | null>(null)
  return (
    <>
      <Stack direction="column" spacing={2} pt={4}>
        <DepositsActions readOnly={readOnly} propertyId={propertyId} reservation={reservation} title={t('pms.booking.reservation.deposits.title')} />
        <DepositsGrid
          readOnly={readOnly}
          deposits={deposits}
          onEditClick={(documentId) => setCheckoutDocumentFormParams({ documentId })}
          selectedDepositIds={selectedDepositIds}
          setSelectedDepositIds={setSelectedDepositIds}
        />
      </Stack>
      {checkoutDocumentFormParams !== null && (
        <CheckoutDocumentForm //
          propertyId={propertyId}
          open={checkoutDocumentFormParams != null}
          onClose={() => setCheckoutDocumentFormParams(null)}
          onSuccess={({ documentId }) => {
            setCheckoutDocumentFormParams(null)
            setPrintDocumentId(documentId)
          }}
          onCreditNoteSuccess={() => setCheckoutDocumentFormParams(null)}
          refetchQueries={['ReservationDetail']}
          {...checkoutDocumentFormParams}
        />
      )}
      {printDocumentId && (
        <DocumentReportViewer
          open={printDocumentId !== null}
          setClose={() => {
            setPrintDocumentId(null)
          }}
          documentId={printDocumentId}
          propertyId={propertyId}
        />
      )}
    </>
  )
}
